<template>
  <div style="display:flex; align-items:left; gap:8px">
    <!-- :disabled="isDisabled || safeOptions.length === 0" -->
  <v-select
      style="width:100%"
      :multiple="multiple"
      :disabled="isDisabled"
      :options="safeOptions"
      :value="value"
      :close-on-select="closeOnSelect"
      append-to-body
      @focusout.native="$emit('focusout', $event)"
      :clearable="clearable"
      :reset-on-options-change="true"
      @input="$emit('input', $event)"
      :dir="$vs.rtl ? 'rtl' : 'ltr'">
      <template v-slot:option="option">
        <span>{{ $displayLabel(option, 'label') }}</span>
      </template>
      <template v-slot:selected-option="option">
        <span>{{ option ? $displayLabel(option, 'label') : '' }}</span>
      </template>
    </v-select>
      <vs-button
        v-if="multiple && !quickCreate"
        color="primary"
        type="filled"
        icon-pack="feather"
        :icon="Array.isArray(value) && value.length === safeOptions.length ? 'icon-check-circle' : 'icon-circle'"
        @click="$emit('select-all', Array.isArray(value) && value.length === safeOptions.length ? [] : safeOptions)"
        ></vs-button>
        <!-- :icon="'icon-check-circle'" -->
        <!-- @click="onSelectAllCategoriesButtonClick(category, percentage, depth.hash)" -->
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
  },
  name: 'SelectField',
  watch: {
    props: {
      immediate: true,
      handler(val) {
        // console.log(val);
      }
    }
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [Object, Array],
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    quickCreate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    safeOptions() {
      return Array.isArray(this.options) ? this.options : []
    }
  },
  created() {
    // console.log(this.options);
  },
  mounted() {
    // console.log(this.isDisabled);
  }
}
</script>

<style scoped>
/* Add component-specific styles here */
</style>
